import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}

export default new Router({
  mode:"hash",
  routes: [
    {
      path: '/',
      name: 'public',
      component: resolve => require(['@/components/public'],resolve),
      children: [
        {
          path: '/',
          redirect: '/Home',
          meta: {
            keepAlive: true
          }
        },
        // 首页
        {
          path:"/Home",
          name: 'Home',
          component: resolve => require(['@/components/Home'],resolve),
        },
        // 功能介绍
        {
          path:"/Features",
          name: 'Features',
          component: resolve => require(['@/components/Features'],resolve),
        },
        // 学习中心
        {
          path:"/Learning",
          name: 'Learning',
          component: resolve => require(['@/components/Learning'],resolve),
        },
        // 更新动态
        {
          path:"/Update",
          name: 'Update',
          component: resolve => require(['@/components/Update'],resolve),
        },
        // 关于我们
        {
          path:"/Aboutus",
          name: 'Aboutus',
          component: resolve => require(['@/components/Aboutus'],resolve),
        },
        // 联系我们
        {
          path:"/Contactus",
          name: 'Contactus',
          component: resolve => require(['@/components/Contactus'],resolve), 
        },

      ],
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js